import { useAppSelector } from "../../redux/hooks";
import { useEffect, useState } from "react";
import axios from "axios";
import LoadingSpinner from "../elements/LoadingSpinner";
import { formatNumber } from "../../redux/thunk";

const SalesOrderDetails = ({ orderNumber, onClose }: any) => {
  const { token } = useAppSelector((store) => store.auth);
  const [loading, setLoading] = useState(true);
  const [orderDetails, setOrderDetails] = useState<any>(null);

  useEffect(() => {
    const getOrderSummary = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/sales/orders/track?orderNumber=${orderNumber}`,
          {
            headers: {
              Authorization: token || "",
            },
          }
        );
        setOrderDetails(response.data.data || []);
      } catch (error) {
        console.error("Failed to fetch orders:", error);
      } finally {
        setLoading(false);
      }
    };

    getOrderSummary();
  }, []);

  return (
    <div
      className="fixed z-40 inset-0 bg-gray-900 bg-opacity-50 overflow-y-auto"
      onClick={onClose}
    >
      <div
        className="bg-white p-4 rounded-md relative mx-auto my-10"
        style={{ width: "600px" }}
      >
        <div className="flex justify-between items-center  text-dark p-2 rounded-t-md">
          <h2 className="text-lg font-semibold">Order Details</h2>
          <button onClick={onClose} className="text-dark">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <hr />
        {loading ? (
          <div className="flex justify-center items-center h-32">
            <LoadingSpinner />
          </div>
        ) : (
          <div className="mb-2">
            <table className="w-full mb-4">
              <thead className="text-left">
                <tr className="leading-10">
                  <th></th>
                  <th>Products</th>
                  <th>Quantity</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody className="text-sm">
                {orderDetails.orderItems.map((item: any, index: any) => (
                  <tr key={index}>
                    <td className="border-b py-1 w-14">
                      <img
                        className="w-full"
                        src={item.image}
                        alt={item.name}
                      />
                    </td>
                    <td className="border-b py-1">
                      {item.name}
                      <br />
                      {item.measurement}
                    </td>
                    <td className="border-b py-1">{item.quantity}</td>
                    <td className="border-b py-1">{item.totalPrice}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="text-sm leading-7">
              <p className="font-semibold text-right">
                Date of Order:{" "}
                {orderDetails.orderDate
                  ? new Date(orderDetails.orderDate).toLocaleString()
                  : new Date(orderDetails.createdAt).toLocaleString()}
              </p>
              <div className="flex items-center justify-between text-sm text-gray-600 mt-2">
                <p>Subtotal:</p>

                <p>
                  ₦
                  {formatNumber(
                    orderDetails.orderItems.reduce(
                      (sum: number, item: any) => sum + item.totalPrice,
                      0
                    )
                  )}
                </p>
              </div>
              <div className="flex items-center justify-between text-sm text-gray-600">
                <p>Service Fee:</p>
                <p>₦{orderDetails?.serviceFee}</p>
              </div>
              <div className="flex items-center justify-between text-sm text-gray-600">
                <p>Delivery Fee:</p>
                <p>₦{orderDetails?.deliveryFee}</p>
              </div>
              <div className="flex items-center justify-between text-base text-green-900 font-semibold mb-2">
                <p>Total:</p>
                <p>₦{(orderDetails?.allItemsTotalPrice).toLocaleString()}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SalesOrderDetails;
